import React, { h } from 'preact'

interface Props {
    className?: string
}

export const SearchIcon: React.FunctionalComponent<Props> = ({ className }) => {
    return (
        <svg
            className={className}
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.715 14.255H16.505L21.495 19.255L20.005 20.745L15.005 15.755V14.965L14.735 14.685C13.595 15.665 12.115 16.255 10.505 16.255C6.915 16.255 4.005 13.345 4.005 9.755C4.005 6.165 6.915 3.255 10.505 3.255C14.095 3.255 17.005 6.165 17.005 9.755C17.005 11.365 16.415 12.845 15.435 13.985L15.715 14.255ZM6.005 9.755C6.005 12.245 8.01501 14.255 10.505 14.255C12.995 14.255 15.005 12.245 15.005 9.755C15.005 7.26501 12.995 5.255 10.505 5.255C8.01501 5.255 6.005 7.26501 6.005 9.755Z"
                fill="#BDBDBD"
            />
        </svg>
    )
}
